import type { ReactNode } from "react"

import { KitchenBrandLink } from "./KitchenBrand"

export function AuthPageShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6 text-foreground md:p-12">
      <div className="w-full max-w-md space-y-8">
        <KitchenBrandLink size="auth" />
        {children}
      </div>
    </div>
  )
}
